import React from 'react';

/**
 * Instagram icon with the brand gradient.
 *
 * The SVG asset declares its gradient with a hardcoded id, so every inlined copy
 * shares the same id and `url(#id)` always resolves to the first one in the DOM.
 * When that first copy sits inside a `display: none` subtree (e.g. the hidden
 * Collabs grid while the invite flow is open) the paint server is not built and
 * every other copy renders transparent. Generating the id per instance avoids it.
 */
export const InstagramGradientIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  const gradientId = `instagram-gradient-${React.useId().replace(/:/g, '')}`;

  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='33' height='33' viewBox='0 0 33 33' fill='none' {...props}>
      <path
        d='M22.8955 0.150024C28.3015 0.150052 32.7002 4.54869 32.7002 9.95471V23.0455C32.7002 28.4515 28.3015 32.8502 22.8955 32.8502H9.80469C4.39867 32.8502 2.79337e-05 28.4515 0 23.0455V9.95471C0 4.54867 4.39865 0.150024 9.80469 0.150024H22.8955ZM9.80469 2.30432C5.57145 2.30432 2.1543 5.72148 2.1543 9.95471V23.0455C2.15432 27.2787 5.57147 30.6959 9.80469 30.6959H22.8955C27.1287 30.6959 30.5459 27.2787 30.5459 23.0455V9.95471C30.5459 5.7215 27.1287 2.30435 22.8955 2.30432H9.80469ZM16.3496 8.15002C20.9524 8.15002 24.7 11.8968 24.7002 16.4996C24.7002 21.1026 20.9526 24.8502 16.3496 24.8502C11.7468 24.85 8 21.1025 8 16.4996C8.00021 11.897 11.747 8.15024 16.3496 8.15002ZM16.3496 10.3043C12.9197 10.3045 10.1545 13.0697 10.1543 16.4996C10.1543 19.9298 12.9195 22.6957 16.3496 22.6959C19.7799 22.6959 22.5459 19.9299 22.5459 16.4996C22.5457 13.0695 19.7797 10.3043 16.3496 10.3043ZM25.0771 5.96838C25.5557 5.96838 26.0151 6.15829 26.3535 6.4967C26.6919 6.83511 26.8818 7.29452 26.8818 7.77307C26.8818 8.25143 26.6917 8.71015 26.3535 9.04846C26.0151 9.38688 25.5557 9.57776 25.0771 9.57776C24.5986 9.57773 24.1392 9.38685 23.8008 9.04846C23.4627 8.71016 23.2725 8.25137 23.2725 7.77307C23.2725 7.29458 23.4625 6.8351 23.8008 6.4967C24.1392 6.15832 24.5986 5.96842 25.0771 5.96838Z'
        fill={`url(#${gradientId})`}
      />
      <defs>
        <linearGradient
          id={gradientId}
          x1='1.05498'
          y1='-0.377399'
          x2='32.6999'
          y2='34.4365'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#F6CE65' />
          <stop offset='0.489999' stopColor='#CA2C69' />
          <stop offset='1' stopColor='#971994' />
        </linearGradient>
      </defs>
    </svg>
  );
};
